import React, { Component } from 'react';

class Video extends Component {
	render() {
		return (
			<div>
				<h1 className="video__heading">
					<em>the</em> HEALTHIEST VERSION <br /><em>of your skin, in four</em> EASY STEPS
				</h1>
				<section className="video product-2">
					<div className="video-tag">
						<div className="c-video"></div>
					</div>
				</section>
			</div>
		);
	}
}


export default Video;